import React from "react";
import { Card, Tag, Space, Typography } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { StarFilled } from "@ant-design/icons";

const { Paragraph, Text } = Typography;

export default function PostCard({ post }) {
  const nav = useNavigate();
  const [isBookmarked, setIsBookmarked] = useState(false);

  // 检查文章是否被书签标记
  useEffect(() => {
    const savedBookmarks = JSON.parse(localStorage.getItem("postBookmarks") || "{}");
    setIsBookmarked(!!savedBookmarks[post.id]);
  }, [post.id]);

  return (
    <Card
      hoverable
      className="card-glow"
      styles={{ 
        body: { 
          padding: 20, 
          minHeight: 220, 
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        } 
      }}
      onClick={() => nav(`/post/${post.id}`)}
    >
      <div>
        <div className="post-card-title" style={{ 
          fontSize: 20, 
          fontWeight: 650, 
          marginBottom: 12, 
          lineHeight: 1.4,
          minHeight: 50, 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          color: 'var(--theme-primary)'
        }}>
          {post.title}
          {/* 书签标记 - 使用星星图标 */}
          {isBookmarked && (
            <StarFilled 
              style={{ 
                color: 'var(--theme-primary)', 
                fontSize: 18,
                marginLeft: 8
              }} 
            />
          )}
        </div>

        <Paragraph className="post-card-summary" style={{ 
          margin: 0, 
          lineHeight: 1.5,
          minHeight: 48, 
          display: 'flex',
          alignItems: 'center',
          color: 'var(--theme-text)'
        }} ellipsis={{ rows: 2 }}>
          {post.summary || post.content}
        </Paragraph>
      </div>

      <div style={{ 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center",
        marginTop: 16, 
        gap: 8,
        minHeight: 36 
      }}>
        <Space size={6} wrap style={{ flex: 1 }}>
          {(post.tags || []).slice(0, 3).map((t) => (
            <Tag 
              key={t} 
              size="small"
              className="post-card-tag"
              style={{ 
                background: "var(--theme-card-bg)",
                border: "1px solid var(--theme-card-border)",
                color: 'var(--theme-primary)'
              }}
            >
              {t}
            </Tag>
          ))}
        </Space>

        <Text style={{ 
          color: "var(--theme-text)",
          fontSize: 12,
          whiteSpace: 'nowrap'
        }}>
          {dayjs(post.createdAt).format("YYYY-MM-DD")}
        </Text>
      </div>
    </Card>
  );
}